import {AsyncInlineError, cache, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserRepositoriesFactory from '../Repositories/factory.js'

/**
 * Use case to get the list of buyer intentions
 */
class GetBuyerIntentionsUserUseCase extends UseCase {
  #config
  #repository

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  /**
   * Static factory method
   * @param {Object} params
   * @param {Object} params.config
   * @returns {GetBuyerIntentionsUserUseCase}
   */
  static create({config}) {
    return new GetBuyerIntentionsUserUseCase({
      config,
      repository: UserRepositoriesFactory.httpUserRepository({config})
    })
  }

  /**
   * Execute the use case
   * @returns {Promise<Object>} Buyer intentions list
   */
  @cache({ttl: '60 minutes', cacheKeyString: 'GetBuyerIntentionsUserUseCase#execute'})
  @tracer({metric: 'GetBuyerIntentionsUserUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    const [error, buyerIntentionsList] = await this.#repository.getBuyerIntentions()

    if (error) return Promise.reject(error)

    return buyerIntentionsList.value
  }
}

export const factory = GetBuyerIntentionsUserUseCase.create
